import React, { useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'

const Navbar = () => {
  const { user, logout } = useContext(AuthContext)
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <nav className='bg-white shadow-lg'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='flex justify-between h-16'>
          <div className='flex'>
            <Link to='/' className='flex items-center'>
              <span className='text-2xl font-bold text-primary-600'>
                EduFlow
              </span>
            </Link>
            {user && (
              <div className='hidden sm:ml-6 sm:flex sm:space-x-8'>
                <Link
                  to='/dashboard'
                  className='inline-flex items-center px-1 pt-1 text-sm font-medium text-gray-900 hover:text-primary-600'
                >
                  Dashboard
                </Link>
                <Link
                  to='/courses'
                  className='inline-flex items-center px-1 pt-1 text-sm font-medium text-gray-900 hover:text-primary-600'
                >
                  Courses
                </Link>
                <Link
                  to='/my-courses'
                  className='inline-flex items-center px-1 pt-1 text-sm font-medium text-gray-900 hover:text-primary-600'
                >
                  My Courses
                </Link>
                {user.role !== 'instructor' && (
                  <>
                    <Link
                      to='/assignments'
                      className='inline-flex items-center px-1 pt-1 text-sm font-medium text-gray-900 hover:text-primary-600'
                    >
                      Assignments
                    </Link>
                    <Link
                      to='/quizzes'
                      className='inline-flex items-center px-1 pt-1 text-sm font-medium text-gray-900 hover:text-primary-600'
                    >
                      Quizzes
                    </Link>
                  </>
                )}
                {user.role === 'instructor' && (
                  <Link
                    to='/create-course'
                    className='inline-flex items-center px-1 pt-1 text-sm font-medium text-primary-600 hover:text-primary-700'
                  >
                    + Create Course
                  </Link>
                )}
              </div>
            )}
          </div>
          <div className='flex items-center'>
            {user ? (
              <div className='flex items-center space-x-4'>
                <Link
                  to='/profile'
                  className='text-gray-700 hover:text-primary-600'
                >
                  {user.first_name} {user.last_name}
                </Link>
                <button
                  onClick={handleLogout}
                  className='bg-primary-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-primary-700'
                >
                  Logout
                </button>
              </div>
            ) : (
              <div className='flex items-center space-x-4'>
                <Link
                  to='/login'
                  className='text-gray-700 hover:text-primary-600'
                >
                  Login
                </Link>
                <Link
                  to='/register'
                  className='bg-primary-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-primary-700'
                >
                  Register
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
